var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      this.$route.path != '/' &&
        !this.$route.path.includes('categorie') &&
        !_vm.noHeaderFooter
    )?_c('Header'):(!_vm.noHeaderFooter)?_c('header-banner'):_vm._e(),_c('content',[_c('router-view',{key:_vm.$route.fullPath})],1),(!_vm.noHeaderFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }